export class DateTimeUtils {
  private static readonly secondsInADay = 86400;
  private static readonly secondsInAHour = 3600;
  private static readonly secondsInAMinute = 60;

  /**
   * Generates current time in seconds.
   */
  public static getCurrentTimeInSeconds(): number {
    return (Date.now() / 1000);

  }

  /**
   * Converts the given time in seconds into a string with the following format: ##:##:##
   * @param seconds The number in seconds.
   */
  public static generateRuntimeBySeconds(seconds: number): string {
    const runtime = new Date(seconds * 1000).toUTCString().substring(17, 25);

    return runtime.startsWith('00:') ? runtime.substring(3) : runtime;
  }

  /**
   * Converts the given time in seconds into an object segregated by Days, Hours, Minutes and Seconds.
   * @param durationInSeconds The number in seconds.
   */
  public static generateRuntimeObjectBySeconds(durationInSeconds: number)
      : { days: number; hours: number; minutes: number; seconds: number } {
    const days = Math.floor(durationInSeconds / DateTimeUtils.secondsInADay);
    const daysTotalInSeconds = DateTimeUtils.secondsInADay * days;

    const hours = Math.floor(
      (durationInSeconds - daysTotalInSeconds) / DateTimeUtils.secondsInAHour
    );
    const daysTotalInHours = DateTimeUtils.secondsInAHour * hours;

    const minutes = Math.floor(
      (durationInSeconds - (daysTotalInSeconds + daysTotalInHours)) / DateTimeUtils.secondsInAMinute
    );
    const daysTotalInMinutes = DateTimeUtils.secondsInAMinute * minutes;

    const seconds = Math.floor(
      durationInSeconds - (daysTotalInSeconds + daysTotalInHours + daysTotalInMinutes)
    );

    return { days, hours, minutes, seconds };
  }

  /**
   * Converts the object generated by generateRuntimeObjectBySeconds into string values while padding the values if
   * being single digit.
   * @param runtime The object generated by generateRuntimeObjectBySeconds.
   * @see generateRuntimeObjectBySeconds
   */
  public static padRuntimeValues(runtime: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }): { days: string; hours: string; minutes: string; seconds: string } {
    return {
      days: runtime.days.toString().padStart(2, '0'),
      hours: runtime.hours.toString().padStart(2, '0'),
      minutes: runtime.minutes.toString().padStart(2, '0'),
      seconds: runtime.seconds.toString().padStart(2, '0')
    };
  }
}
